import {
  ApiaUtil,
  ApiaUtilModalHandler,
  SimpleButton,
  TOpenModal,
} from '@apia/components';
import { AdditionalFiltersComponent } from './components/AdditionalFiltersComponent';
import { TableController } from '../TableController';

export class AdditionalFiltersModalController {
  private modalHandler: ApiaUtilModalHandler | null = null;

  constructor(private tableController: TableController) {}

  protected getModalDefinition(): TOpenModal {
    return {
      children: (
        <AdditionalFiltersComponent tableController={this.tableController} />
      ),
      onConfirm: () => {
        // this.emitter.emit('onSelectRows', this.currentSelection || []);
      },
      confirmProps: {
        hideConfirmButton: true,
        hideCancelButton: true,
        additionalButtons: (
          <>
            <SimpleButton>TODO:BUSCAR</SimpleButton>,
            <SimpleButton variant="outline">TODO:FILTER</SimpleButton>
          </>
        ),
      },
      draggable: true,
      size: 'lg',
    };
  }
  public async openModal(properties?: TOpenModal) {
    this.modalHandler = ApiaUtil.instance.modals.open({
      ...this.getModalDefinition(),
      ...properties,
    });
  }
  public closeModal() {
    this.modalHandler?.close();
  }
}
